import { Dialog, Heading } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import { Form } from 'formik';
import styled from 'styled-components';

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${tokens.space.loose};
`;

export const StyledDialog = styled(Dialog)`
  max-width: 600px;

  ${tokens.mediaQueries.s} {
    width: 100%;
    max-width: 100%;
  }
`;

export const Title = styled(Heading)`
  font-size: 21px;
  font-family: ${tokens.font.family.ifood.body};
  line-height: ${tokens.lineHeights.m};
  max-width: 500px;
  text-align: center;
`;
